import { gql } from "@apollo/client";

export const SEARCH_INVOICE = gql`
  query searchInvoice($q: String!, $limit: Int!, $offset: Int!, $filters: [FilterInput]) {
    searchInvoice(q: $q, limit: $limit, offset: $offset, filters: $filters) {
      rentalAmount
      customerType
      insuranceAmount
      damageAmount
      addonsAmount
      taxAmount
      dueDate
      dueAmount
      lastSent
      booking {
        referenceNumber
      }
      tax {
        amount
        appliedBy
        appliedDate
        code
      }
      dateCreated
      dateUpdated
      createdBy
      updatedBy
      discount {
        appliedBy
        appliedDate
        isPercent
        code
        amount
      }
      invoiceRef
      status
      locked
      invoiceType
      startDate
      endDate
      totalPayableAmount
      confirmedPaidAmount
      confirmedRefundAmount
      otherRefunds
      otherCharges {
        amount
        name
      }
      id
      customer {
        id
        firstName
        lastName
      }
      businessCustomer {
        id
        businessName
        registrationNumber
        VAT
      }
      sageAccountingInvoiceId
      sentToXero
    }
  }
`;

export const SEARCH_BUSINESS_CUSTOMER_INVOICE = gql`
  query searchBusinessCustomerInvoice($businessCustomerId: ID, $q: String!) {
    searchBusinessCustomerInvoice(businessCustomerId: $businessCustomerId, q: $q) {
      rentalAmount
      customerType
      insuranceAmount
      damageAmount
      addonsAmount
      taxAmount
      dueDate
      dueAmount
      lastSent
      booking {
        referenceNumber
      }
      tax {
        amount
        appliedBy
        appliedDate
        code
      }
      dateCreated
      dateUpdated
      createdBy
      updatedBy
      discount {
        appliedBy
        appliedDate
        isPercent
        code
        amount
      }
      invoiceRef
      status
      locked
      invoiceType
      startDate
      endDate
      totalPayableAmount
      confirmedPaidAmount
      confirmedRefundAmount
      otherRefunds
      otherCharges {
        amount
        name
      }
      id
      customer {
        id
        firstName
        lastName
      }
      businessCustomer {
        id
        businessName
        registrationNumber
        VAT
      }
      sageAccountingInvoiceId
      sentToXero
    }
  }
`;